import { render, staticRenderFns } from "./PriceLevel.vue?vue&type=template&id=3355bbc1&scoped=true"
import script from "./PriceLevel.vue?vue&type=script&lang=js"
export * from "./PriceLevel.vue?vue&type=script&lang=js"
import style0 from "./PriceLevel.vue?vue&type=style&index=0&id=3355bbc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3355bbc1",
  null
  
)

export default component.exports